/**
 * Loading fallback component for lazy-loaded routes.
 * Displayed inside Suspense boundaries while route chunks are being fetched.
 * Uses skeleton placeholders to indicate content is loading.
 *
 * @module components/route-loading-fallback
 */

import { Skeleton } from '@/components/ui/skeleton'

/**
 * Full-page loading skeleton shown while lazy-loaded route components are fetched.
 * Mimics a typical page layout with a header area, sidebar placeholder, and content blocks
 * to reduce perceived loading time and prevent layout shift.
 */
export function RouteLoadingFallback() {
  return (
    <div className="flex h-full w-full flex-col gap-6 p-6">
      {/* Header skeleton */}
      <div className="flex items-center gap-4">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="ml-auto h-8 w-24" />
      </div>

      {/* Content area skeleton */}
      <div className="flex flex-1 gap-6">
        {/* Main content */}
        <div className="flex flex-1 flex-col gap-4">
          <Skeleton className="h-32 w-full rounded-lg" />
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            <Skeleton className="h-40 rounded-lg" />
            <Skeleton className="h-40 rounded-lg" />
            <Skeleton className="h-40 rounded-lg" />
          </div>
          <Skeleton className="h-24 w-full rounded-lg" />
        </div>
      </div>
    </div>
  )
}
